<div fxLayout="column" fxLayoutGap="20px" class="layout-padd" fxLayoutAlign="center center" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

  <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd full-w">
      <mat-icon color="primary" style="font-size: 3em;">category</mat-icon>
  </div>

  <div fxLayoutGap="10px">

      <div fxLayoutAlign="center center" class="text-center layout-padd">
          <span [innerHTML]="'dialoSm' | translate:{'sm': currSalemethod.name}"></span>
      </div>

     

  </div>

  <button mat-stroked-button class="full-w dark-ico" (click)="closeDial()" angulartics2On="click" angularticsAction="" angularticsCategory="order">
  <span class="mat-title">{{'alertAchiveSmComponent.close'|translate}}</span>
</button>

</div>